/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Select } from "./ui/Select";

const STATE_NAMES: Record<string, string> = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado",
  CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho",
  IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
  ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan", MN: "Minnesota",
  MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada",
  NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico", NY: "New York", NC: "North Carolina",
  ND: "North Dakota", OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania",
  RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas",
  UT: "Utah", VT: "Vermont", VA: "Virginia", WA: "Washington", WV: "West Virginia",
  WI: "Wisconsin", WY: "Wyoming", DC: "District of Columbia",
};

const STATE_OPTIONS = Object.entries(STATE_NAMES).map(([code, name]) => ({
  value: code,
  label: `${name} (${code})`,
}));

/**
 * The one US-state picker: full state names, typeable on name or code. `allowNone` prepends a
 * "No state" option for records where the state is genuinely optional.
 */
export function StateSelect({
  value,
  onChange,
  className,
  label,
  placeholder = "Select a state…",
  allowNone = false,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  label?: string;
  placeholder?: string;
  allowNone?: boolean;
}) {
  const options = allowNone
    ? [{ value: "", label: "No state" }, ...STATE_OPTIONS]
    : STATE_OPTIONS;
  return (
    <Select
      className={className ?? ""}
      {...(label === undefined ? {} : { label })}
      value={value}
      onChange={onChange}
      options={options}
      searchable
      placeholder={placeholder}
    />
  );
}
